<template>
  <el-container>
    <el-aside width="200px" style="background-color:#212d3c;max-height:100vh;">
      <el-menu router :default-active="defaultIndex" :unique-opened="true">

        <el-submenu v-for="(nav, key) in navs" :index="key + ''" :key="key">
          <template slot="title"><i :class="nav.icon"></i>{{nav.title}}</template>
          <template v-for="(item, ck) in nav.items">
            <el-submenu v-if="item.items" :index="key + '-' + ck" :key="key + '-' + ck">
              <template slot="title">{{item.title}}</template>
              <el-menu-item v-for="(subItem) in item.items" :index="subItem.url" :key="subItem.url">{{subItem.title}}</el-menu-item>
            </el-submenu>
            <el-menu-item v-else :index="item.url" :key="item.url">{{item.title}}</el-menu-item>
          </template>
        </el-submenu>
        <el-menu-item index="logout">
          <i class="fa fa-sign-out" style="font-size:18px;width:24px;text-align:center;margin-right:5px;"></i>
          <span slot="title" @click="logout">退出登录</span>
        </el-menu-item>

<!--        <el-submenu index="1">-->
<!--          <template slot="title"><i class="el-icon-document"></i>知识点管理</template>-->
<!--          <el-menu-item-group>-->
<!--            <el-menu-item index="/word">词汇</el-menu-item>-->
<!--            <el-menu-item index="/grammar">语法</el-menu-item>-->
<!--            <el-menu-item index="/kewen">课文</el-menu-item>-->
<!--            <el-menu-item index="/sentence">句子</el-menu-item>-->
<!--            <el-menu-item index="/graphictext">解释</el-menu-item>-->
<!--            <el-menu-item index="/review/sentences">复习例句</el-menu-item>-->
<!--          </el-menu-item-group>-->
<!--        </el-submenu>-->
<!--        <el-submenu index="2">-->
<!--          <template slot="title"><i class="el-icon-setting"></i>题目管理</template>-->
<!--          <el-menu-item-group>-->
<!--            <el-menu-item index="/exercise/index">全部题目</el-menu-item>-->
<!--            <el-menu-item index="/kexercise/word">词汇题目</el-menu-item>-->
<!--            <el-menu-item index="/kexercise/grammar">语法题目</el-menu-item>-->
<!--            <el-menu-item index="/kexercise/kewen">课文题目</el-menu-item>-->
<!--            <el-menu-item index="/exercise/check">题目校对</el-menu-item>-->
<!--            <el-menu-item index="/exercise/qa">题目解析</el-menu-item>-->
<!--          </el-menu-item-group>-->
<!--        </el-submenu>-->
<!--        <el-submenu index="3">-->
<!--          <template slot="title"><i class="el-icon-setting"></i>水平测试</template>-->
<!--          <el-menu-item-group>-->
<!--            <el-menu-item index="/testexercise/1">词汇题目</el-menu-item>-->
<!--            <el-menu-item index="/testexercise/2">语法题目</el-menu-item>-->
<!--          </el-menu-item-group>-->
<!--        </el-submenu>-->
<!--        <el-submenu index="4">-->
<!--          <template slot="title"><i class="el-icon-setting"></i>课程管理</template>-->
<!--          <el-menu-item-group>-->
<!--            <el-menu-item index="/collection">课程编排</el-menu-item>-->
<!--            <el-menu-item index="/lesson">课程列表</el-menu-item>-->
<!--          </el-menu-item-group>-->
<!--        </el-submenu>-->
<!--        <el-submenu index="5">-->
<!--          <template slot="title"><i class="el-icon-setting"></i>拼音管理</template>-->
<!--          <el-menu-item-group>-->
<!--            <el-menu-item index="/pinyinexercises">题目</el-menu-item>-->
<!--            <el-menu-item index="/pinyin">拼音</el-menu-item>-->
<!--            <el-menu-item index="/pinyinintro">介绍</el-menu-item>-->
<!--            <el-menu-item index="/pinyincomb">组合</el-menu-item>-->
<!--            <el-menu-item index="/pinyinlesson">课程</el-menu-item>-->
<!--          </el-menu-item-group>-->
<!--        </el-submenu>-->
<!--        <el-submenu index="11">-->
<!--          <template slot="title"><i class="el-icon-document"></i>Talk管理</template>-->
<!--          <el-menu-item-group>-->
<!--            <el-menu-item index="/talk/topics">话题列表</el-menu-item>-->
<!--            <el-menu-item index="/talk/words">猜词列表</el-menu-item>-->
<!--          </el-menu-item-group>-->
<!--        </el-submenu>-->
<!--        <el-submenu index="6">-->
<!--          <template slot="title"><i class="el-icon-setting"></i>基础数据</template>-->
<!--          <el-menu-item-group>-->
<!--            <el-menu-item index="/grammartype">语法分类</el-menu-item>-->
<!--            <el-menu-item index="/exercise/type">题目类型</el-menu-item>-->
<!--            <el-menu-item index="/kewen/role">课文角色</el-menu-item>-->
<!--          </el-menu-item-group>-->
<!--        </el-submenu>-->
<!--        <el-submenu index="7">-->
<!--          <template slot="title"><i class="el-icon-setting"></i>翻译管理</template>-->
<!--          <el-menu-item index="/locale/all">全部</el-menu-item>-->
<!--          <el-submenu index="7-2">-->
<!--            <template slot="title">知识点翻译</template>-->
<!--            <el-menu-item index="/locale/word">词汇翻译</el-menu-item>-->
<!--            <el-menu-item index="/locale/grammar">语法翻译</el-menu-item>-->
<!--            <el-menu-item index="/locale/graphictranslation">语法解释</el-menu-item>-->
<!--            <el-menu-item index="/locale/kewensentence">课文例句</el-menu-item>-->
<!--            <el-menu-item index="/locale/grammarsentence">语法例句</el-menu-item>-->
<!--            <el-menu-item index="/locale/wordsentence">词汇例句</el-menu-item>-->
<!--            <el-menu-item index="/locale/othersentence">其他例句</el-menu-item>-->
<!--            <el-menu-item index="/locale/lesson">课程翻译</el-menu-item>-->
<!--          </el-submenu>-->
<!--          <el-menu-item index="/locale/exercise">题目翻译</el-menu-item>-->
<!--          <el-menu-item index="/locale/pinyin">拼音翻译</el-menu-item>-->
<!--          <el-menu-item index="/locale/help">帮助翻译</el-menu-item>-->
<!--          <el-submenu index="7-3">-->
<!--            <template slot="title">基础数据</template>-->
<!--            <el-menu-item index="/locale/grammartype">语法分类</el-menu-item>-->
<!--            <el-menu-item index="/locale/exrtype">题型翻译</el-menu-item>-->
<!--            <el-menu-item index="/locale/level">等级翻译</el-menu-item>-->
<!--          </el-submenu>-->
<!--          <el-menu-item index="/locale/php">其他翻译</el-menu-item>-->
<!--        </el-submenu>-->
<!--        <el-submenu index="8">-->
<!--          <template slot="title"><i class="el-icon-document"></i>数据导入</template>-->
<!--          <el-menu-item-group>-->
<!--            <el-menu-item index="/dataupdate">例句拼音修改</el-menu-item>-->
<!--          </el-menu-item-group>-->
<!--        </el-submenu>-->
<!--        <el-menu-item index="9">-->
<!--          <i class="fa fa-sign-out" style="font-size:18px;width:24px;text-align:center;margin-right:5px;"></i>-->
<!--          <span slot="title" @click="logout">退出登录</span>-->
<!--        </el-menu-item>-->
      </el-menu>
      <div v-if="testSite" style="text-align:center;color:#F56C6C;">
        <span :title="`测试后台仅用来做课程测试，切勿用来修改正式上的数据，且所有修改的内容都无法同步到正式环境。该环境的数据需要将app切换到${apiEnv}查看`">测试后台 <i class="el-icon-question"></i></span>
      </div>
    </el-aside>
    <el-container>
      <el-main>
        <keep-alive include="LessonList,LessonCollection">
          <router-view></router-view>
        </keep-alive>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import {getNavItems} from "@/views/layouts/navs.js";

export default {
  name: 'App',
  data () {
    return {
      defaultIndex: this.$route.path || '/word',
      testSite: false,
      apiEnv: '',
      navs: [],
    }
  },
  created() {
    getNavItems().then(navs => {
      this.navs = navs;
    });
  },
  mounted() {
    if (!/^https?:\/\/cms\.superchinese\.com\//i.test(location.href)) {
      if (/^https?:\/\/pre[-.]/.test(location.href)) {
        this.apiEnv = '内容环境';
      } else {
        this.apiEnv = 'hsb开发环境';
      }
      this.testSite = true;
      this.showConfirmTestSite();
    } else {
      this.apiEnv = '正式环境';
    }
  },
  methods: {
    logout () {
      localStorage.removeItem('authKey')
      sessionStorage.removeItem('authKey')
      this.$router.push({path: '/login'})
    },
    showConfirmTestSite() {
      const h = this.$createElement;
      const style = {style: 'color:#F56C6C;font-weight:bold;'};
      this.$confirm(h('p', null, [
        '您当前访问的是',
        h('span', style, this.apiEnv),
        '后台，仅用来做',
        h('span', style, '课程测试使用'),
        '且该站点所有的修改都',
        h('span', style, '无法更新到正式环境'),
        '。如果您需要修改用户反馈的问题或者正式上的内容，请到正式环境后台修改。'
      ]), '系统提示', {
        confirmButtonText: '我已知晓并继续使用测试后台',
        cancelButtonText: '我要去正式后台修改数据',
        type: 'warning',
        closeOnClickModal: false,
        closeOnPressEscape: false,
        showClose: false,
      }).then(() => {
        this.$message({
          type: 'success',
          duration: 15000,
          showClose: true,
          message: `当前使用的是测试后台，可通过左下角的红色标签来区分。该环境的数据需要将app切换到${this.apiEnv}查看`
        });
      }).catch(() => {
        location.href = 'https://cms.superchinese.com';
      });
    }
  }
}
</script>
